<template>
  <section class="control_2">
    <div class="img-wrapper" bg-url="@/auto/assets/image/2/1.png" v-bg></div>
    <div class="font_box">
      <h3>为全天候使用的</h3>
      <h3>AR 系统设计</h3>
    </div>
  </section>
</template>

<script>
import { videoPlayByVisibleArea } from '@/utils'

export default {
  name: 'Control',

  methods: {
    controlPin() {
      this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.control_2',
          start: 'top bottom',
          end: '+=500 top',
          pin: true,
          // markers: true
        },
      })
    },

    runControl() {
      const tl = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.font_box',
          start: 'top top',
          end: '300px top',
          scrub: 0.1,
          // markers: true
        },
      })

      tl.addLabel('font')
      tl.to('.font_box_2', { top: 100, opacity: 0 }, 'font')
    },

    onLaunch() {
      // this.controlPin()
      // this.runControl()
    },
  },
}
</script>

<style lang="less" scoped>
h3 {
  text-align: center;
  font-family: Flyme Sans VF;
  font-size: 72px;
  font-style: normal;
  font-weight: 700;
  line-height: 92px; /* 135% */
  letter-spacing: 4.8px;
  background: linear-gradient(99deg, #ffdfdf 8.71%, #7e8bff 83.77%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.control_2 {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  // border: 2px solid yellow;
  .img-wrapper {
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-position: center center;
    background-size: cover;
  }
  .font_box {
    position: absolute;
    left: 50%;
    top: 20%;
    margin: auto;
    transform: translateX(-50%);
    z-index: 1;
  }
}
</style>
